<template>
  <div>
    <HeadlineContainer headline="Companies" :breadcrumbs="[{text: 'Companies'}]">
      <div class="btn-group">
        <button type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown">
          <i class="fa fa-cogs"></i> Functions <span class="caret"></span>
        </button>

        <ul class="dropdown-menu">
          <li>
            <router-link to="/companies/create">
              <i class="fa fa-plus"></i> Create
            </router-link>
          </li>

          <li>
            <router-link to="/companies/imports/create">
              <i class="fa fa-cloud-upload-alt"></i> Import
            </router-link>
          </li>
        </ul>
      </div>
    </HeadlineContainer>

    <div v-if="!loading" class="container">
      <CompanyList :portals="portals" :projects="projects" :tags="tags"/>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import CompanyList from '../../../components/Companies/Companies/Panels/List'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'

export default {
  components: {CompanyList, HeadlineContainer},

  data() {
    return {
      portals: null,
      projects: null,
      tags: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.loading = true

      Promise.all([
        http.get('/api/v2/portals', {page_size: 100}),
        http.get('/api/v2/projects', {page_size: 100, 'filter[status]': 'active'}),
      ]).then(responses => {
        this.portals = responses[0].data.data

        this.projects = responses[1].data.data

        this.loading = false
      })
    }
  }
}
</script>
